/* ==========================================================================
   Blink Box - Breadcrumb analytics
   Tracks only breadcrumb usage by source page type and breadcrumb level.
========================================================================== */
(function () {
  'use strict';

  if (window.__blinkboxBreadcrumbAnalyticsLoaded) return;
  window.__blinkboxBreadcrumbAnalyticsLoaded = true;

  function analyticsProcessingAllowed() {
    const fn = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed;

    if (typeof fn !== 'function') return true;

    try {
      return fn.call(window.Shopify.customerPrivacy);
    } catch (error) {
      return false;
    }
  }

  function publishShopifyEvent(name, payload) {
    if (!analyticsProcessingAllowed()) return;
    if (typeof window.Shopify?.analytics?.publish !== 'function') return;

    try {
      const result = window.Shopify.analytics.publish(name, payload);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (error) {
      // Analytics must never interrupt navigation.
    }
  }

  function sendGoogleEvent(name, params) {
    if (!analyticsProcessingAllowed()) return;
    if (typeof window.gtag !== 'function') return;

    try {
      window.gtag('event', name, params);
    } catch (error) {
      // Google measurement is optional.
    }
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('[data-breadcrumb-link]');
    if (!link) return;

    const breadcrumbs = link.closest('[data-breadcrumbs]');
    if (!breadcrumbs) return;

    const payload = {
      source_page_type: breadcrumbs.dataset.breadcrumbSourcePageType || '',
      breadcrumb_type: link.dataset.breadcrumbType || ''
    };

    if (!payload.breadcrumb_type) return;

    publishShopifyEvent('blinkbox_breadcrumb_click', payload);
    sendGoogleEvent('breadcrumb_click', payload);
  }, true);
})();
